/* TWE · The Wolf Editorial — motor de movimiento e interacción del home revista.
   Sin dependencias. Cada módulo se inicia por atributo data-twe-* y se reinicia
   cuando el editor de temas recarga una sección (shopify:section:load). */
(function () {
  'use strict';
  var RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var money = function (cents) { return '$' + Math.round(cents / 100).toLocaleString('es-CL'); };

  function onView(el, cb, opts) {
    if (!('IntersectionObserver' in window)) { cb(true); return; }
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { cb(e.isIntersecting, e); }); }, opts || { threshold: 0.15 });
    io.observe(el); return io;
  }

  /* ---------- texto por palabras + revelado ---------- */
  function split(el) {
    if (el.dataset.tweSplitDone) return; el.dataset.tweSplitDone = '1';
    var i = 0;
    (function walk(node) {
      Array.prototype.slice.call(node.childNodes).forEach(function (n) {
        if (n.nodeType === 3) {
          var parts = n.textContent.split(/(\s+)/), frag = document.createDocumentFragment();
          parts.forEach(function (p) {
            if (!p) return;
            if (/^\s+$/.test(p)) { frag.appendChild(document.createTextNode(p)); return; }
            var w = document.createElement('span'); w.className = 'twe-w';
            var s = document.createElement('span'); s.textContent = p; s.style.setProperty('--i', i++);
            w.appendChild(s); frag.appendChild(w);
          });
          n.parentNode.replaceChild(frag, n);
        } else if (n.nodeType === 1 && !n.classList.contains('twe-w')) { walk(n); }
      });
    })(el);
  }
  function reveals(root) {
    $$('[data-twe-split]', root).forEach(function (el) { split(el); if (!el.hasAttribute('data-twe-reveal')) el.setAttribute('data-twe-reveal', 'words'); });
    $$('[data-twe-reveal],[data-twe-mask]', root).forEach(function (el) {
      if (RM) { el.classList.add('is-in'); return; }
      var io = onView(el, function (v) { if (v) { el.classList.add('is-in'); io && io.disconnect(); } }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    });
    // las palabras usan su propio transform: el contenedor no debe desplazarse
  }

  /* ---------- videos perezosos: cargan cerca del viewport, se pausan fuera ---------- */
  function videos(root) {
    $$('video[data-twe-lazy]', root).forEach(function (v) {
      v.muted = true; v.setAttribute('muted', ''); v.playsInline = true;
      onView(v, function (vis) {
        if (vis && !v.dataset.loaded) {
          $$('source[data-src]', v).forEach(function (s) { s.src = s.dataset.src; });
          v.load(); v.dataset.loaded = '1';
        }
        if (v.closest('.twe-slide') && !v.closest('.twe-slide').classList.contains('is-active')) return;
        if (vis) { var p = v.play(); p && p.catch(function () {}); } else { v.pause(); }
      }, { rootMargin: '200px 0px', threshold: 0 });
    });
  }

  /* ---------- slideshow con crossfade (portada, puertas) ---------- */
  function slides(root) {
    $$('[data-twe-slides]', root).forEach(function (box) {
      var ss = $$('.twe-slide', box); if (ss.length < 2) { ss[0] && ss[0].classList.add('is-active'); return; }
      var i = 0, ms = +(box.dataset.interval || 5200), off = +(box.dataset.offset || 0), t = null, visible = true;
      function show(n) {
        var prev = ss[i]; ss.forEach(function (x) { x.classList.remove('is-prev'); });
        prev.classList.remove('is-active'); prev.classList.add('is-prev');
        setTimeout(function () { prev.classList.remove('is-prev'); var ov = $('video', prev); ov && ov.pause(); }, 1500);
        i = (n + ss.length) % ss.length; ss[i].classList.add('is-active');
        var nv = $('video', ss[i]); if (nv && nv.dataset.loaded) { try { nv.currentTime = 0; } catch (e) {} var p = nv.play(); p && p.catch(function () {}); }
      }
      function loop() { clearTimeout(t); if (!visible || document.hidden || RM) return; t = setTimeout(function () { show(i + 1); loop(); }, ms); }
      ss.forEach(function (s, k) { s.classList.toggle('is-active', k === 0); });
      onView(box, function (v) { visible = v; loop(); }, { threshold: 0.05 });
      document.addEventListener('visibilitychange', loop);
      setTimeout(loop, off);
    });
  }

  /* ---------- historia que corre sola (portada) ---------- */
  function stories(root) {
    $$('[data-twe-story]', root).forEach(function (st) {
      var items = $$('.twe-story__item', st), bars = $$('.twe-story__bar', st); if (!items.length) return;
      var i = -1, dur = +(st.dataset.dur || 4200), t = null, left = dur, started = 0, paused = false;
      st.style.setProperty('--dur', dur + 'ms');
      function go(n) {
        i = (n + items.length) % items.length;
        items.forEach(function (it, k) { it.classList.toggle('is-active', k === i); });
        bars.forEach(function (b, k) { b.classList.toggle('is-done', k < i); b.classList.remove('is-active'); });
        void st.offsetWidth; bars[i] && bars[i].classList.add('is-active');
        left = dur; run();
      }
      function run() { clearTimeout(t); if (paused || RM) return; started = Date.now(); t = setTimeout(function () { go(i + 1); }, left); }
      function pause() { if (paused) return; paused = true; clearTimeout(t); left -= Date.now() - started; st.classList.add('is-paused'); }
      function play() { if (!paused) return; paused = false; st.classList.remove('is-paused'); run(); }
      st.addEventListener('mouseenter', pause); st.addEventListener('mouseleave', play);
      st.addEventListener('focusin', pause); st.addEventListener('focusout', play);
      go(0);
    });
  }

  /* ---------- ticker: velocidad y sesgo según el scroll ---------- */
  var tickers = [];
  function ticker(root) {
    $$('[data-twe-ticker]', root).forEach(function (tk) {
      var track = $('.twe-ticker__track', tk), row = $('.twe-ticker__row', tk); if (!track || !row || track.dataset.on) return;
      track.dataset.on = '1'; track.appendChild(row.cloneNode(true)).setAttribute('aria-hidden', 'true');
      if (RM || !track.animate) return;
      var dir = tk.dataset.dir === 'right' ? 1 : -1, w = row.getBoundingClientRect().width;
      var anim = track.animate([{ transform: 'translateX(' + (dir < 0 ? 0 : -w) + 'px)' }, { transform: 'translateX(' + (dir < 0 ? -w : 0) + 'px)' }], { duration: Math.max(16000, w * 22), iterations: Infinity });
      tickers.push({ el: tk, track: track, anim: anim });
    });
  }
  var lastY = window.scrollY, vel = 0;
  function scrollFx() {
    var y = window.scrollY; vel = vel * 0.8 + (y - lastY) * 0.2; lastY = y;
    tickers.forEach(function (t) {
      t.anim.playbackRate = 1 + Math.min(4, Math.abs(vel) / 14);
      t.track.style.setProperty('--skew', Math.max(-8, Math.min(8, -vel / 6)) + 'deg');
    });
    // barra de progreso de lectura + parallax del journal
    var h = document.documentElement.scrollHeight - innerHeight;
    var bar = $('.twe-progress'); bar && bar.style.setProperty('--sp', h > 0 ? (y / h).toFixed(4) : 0);
    $$('[data-twe-par], .twe-par').forEach(function (el) {
      var r = el.getBoundingClientRect(); if (r.bottom < 0 || r.top > innerHeight) return;
      el.style.setProperty('--par', ((r.top + r.height / 2 - innerHeight / 2) * -0.08).toFixed(1) + 'px');
    });
    requestAnimationFrame(scrollFx);
  }

  /* ---------- capítulo con escenario fijo ---------- */
  function chapters(root) {
    $$('[data-twe-steps]', root).forEach(function (cap) {
      var steps = $$('.twe-cap__step', cap), frames = $$('.twe-cap__frame', cap), prog = $$('.twe-cap__prog i', cap), cnt = $('.twe-cap__count', cap);
      function act(k) {
        steps.forEach(function (s, j) { s.classList.toggle('is-active', j === k); });
        frames.forEach(function (f, j) {
          f.classList.toggle('is-active', j === k);
          var v = $('video', f); if (v) { if (j === k) { if (!v.dataset.loaded) { $$('source[data-src]', v).forEach(function (s) { s.src = s.dataset.src; }); v.load(); v.dataset.loaded = '1'; } var p = v.play(); p && p.catch(function () {}); } else v.pause(); }
        });
        prog.forEach(function (p, j) { p.classList.toggle('is-on', j <= k); });
        if (cnt) cnt.textContent = String(k + 1).padStart(2, '0') + ' / ' + String(steps.length).padStart(2, '0');
      }
      act(0);
      /* paso activo = el último cuyo borde superior ya cruzó la línea (50 % en escritorio; 72 % en celular, donde el texto vive bajo el escenario).
         Se calcula en cada scroll, así un deslizamiento rápido no se salta pasos (el observer por franja sí podía). */
      var cur = -1, tick = false;
      function pick() {
        tick = false;
        var r = cap.getBoundingClientRect(); if (r.bottom < 0 || r.top > innerHeight) return;
        var line = innerHeight * (window.matchMedia('(max-width: 899px)').matches ? 0.72 : 0.5), k = 0;
        for (var j = 0; j < steps.length; j++) { if (steps[j].getBoundingClientRect().top < line) k = j; }
        if (k !== cur) { cur = k; act(k); }
      }
      window.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(pick); } }, { passive: true });
      window.addEventListener('resize', pick);
      pick();
    });
  }

  /* ---------- rieles arrastrables (+ auto avance opcional) ---------- */
  function rails(root) {
    $$('[data-twe-rail]', root).forEach(function (rail) {
      if (rail.dataset.on) return; rail.dataset.on = '1';
      var down = false, sx = 0, sl = 0, moved = 0;
      rail.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse') return; down = true; moved = 0; sx = e.clientX; sl = rail.scrollLeft; });
      window.addEventListener('pointermove', function (e) { if (!down) return; var dx = e.clientX - sx; moved = Math.abs(dx); if (moved > 4) rail.classList.add('is-drag'); rail.scrollLeft = sl - dx; });
      window.addEventListener('pointerup', function () { if (!down) return; down = false; setTimeout(function () { rail.classList.remove('is-drag'); }, 0); });
      rail.addEventListener('click', function (e) { if (moved > 6) { e.preventDefault(); e.stopPropagation(); } }, true);
      var sec = rail.closest('.shopify-section') || document;
      function step(d) { var c = rail.firstElementChild; var w = c ? c.getBoundingClientRect().width + 18 : rail.clientWidth * 0.8; var max = rail.scrollWidth - rail.clientWidth - 4; var to = rail.scrollLeft + d * w; if (to > max + w / 2) to = 0; if (to < -w / 2) to = max; rail.scrollTo({ left: to, behavior: RM ? 'auto' : 'smooth' }); }
      $$('[data-twe-prev]', sec).forEach(function (b) { b.addEventListener('click', function () { step(-1); }); });
      $$('[data-twe-next]', sec).forEach(function (b) { b.addEventListener('click', function () { step(1); }); });
      var auto = +(rail.dataset.auto || 0);
      if (auto && !RM) {
        var t = null, hold = false, vis = false;
        var tick = function () { clearTimeout(t); if (hold || !vis || document.hidden) return; t = setTimeout(function () { step(1); tick(); }, auto); };
        rail.addEventListener('pointerenter', function () { hold = true; clearTimeout(t); });
        rail.addEventListener('pointerleave', function () { hold = false; tick(); });
        rail.addEventListener('touchstart', function () { hold = true; clearTimeout(t); setTimeout(function () { hold = false; tick(); }, 7000); }, { passive: true });
        onView(rail, function (v) { vis = v; tick(); }, { threshold: 0.3 });
      }
    });
  }

  /* ---------- puntos sobre looks ---------- */
  function hotspots(root) {
    $$('[data-twe-hot]', root).forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault(); var look = b.closest('.twe-look'); var pop = $('#' + b.getAttribute('aria-controls'));
        $$('.twe-pop.is-open', look).forEach(function (p) { if (p !== pop) p.classList.remove('is-open'); });
        var open = !pop.classList.contains('is-open'); pop.classList.toggle('is-open', open); b.setAttribute('aria-expanded', open);
      });
    });
    $$('.twe-pop__close', root).forEach(function (c) { c.addEventListener('click', function () { c.closest('.twe-pop').classList.remove('is-open'); }); });
  }

  /* ---------- agregar al carrito (usa el evento del tema para el ícono y el cajón) ---------- */
  function addToCart(ids, btn) {
    ids = ids.filter(Boolean); if (!ids.length) return;
    var label = btn && btn.innerHTML; if (btn) btn.setAttribute('aria-busy', 'true');
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: ids.map(function (id) { return { id: +id, quantity: 1 }; }) })
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
      .then(function (cart) {
        var ev = new Event('cart:update', { bubbles: true });
        ev.detail = { resource: cart, sourceId: 'twe', data: { source: 'twe', itemCount: cart.item_count } };
        document.dispatchEvent(ev);
        if (btn) { btn.removeAttribute('aria-busy'); btn.classList.add('is-done'); btn.innerHTML = btn.dataset.done || '✓'; setTimeout(function () { btn.classList.remove('is-done'); btn.innerHTML = label; }, 2400); }
        try { window.Shopify && Shopify.analytics && Shopify.analytics.publish && Shopify.analytics.publish('twe_add', { ids: ids, source: btn && btn.dataset.src }); } catch (e) {}
      })
      .catch(function (err) {
        if (btn) { btn.removeAttribute('aria-busy'); btn.innerHTML = (err && err.description) ? 'Sin stock' : 'Reintentar'; setTimeout(function () { btn.innerHTML = label; }, 2600); }
      });
  }
  function adders(root) {
    $$('[data-twe-add]', root).forEach(function (b) {
      if (b.dataset.on) return; b.dataset.on = '1';
      b.addEventListener('click', function (e) { e.preventDefault(); addToCart(String(b.dataset.tweAdd).split(','), b); });
    });
  }

  /* ---------- arma tu set ---------- */
  function sets(root) {
    $$('[data-twe-set]', root).forEach(function (st) {
      var groups = $$('[data-twe-group]', st), add = $('[data-twe-set-add]', st), total = $('.twe-set__total', st), names = $('.twe-set__names', st);
      function sel(g) { return $('[aria-pressed="true"]', g); }
      function upd() {
        var a = groups.map(sel), sum = 0, ids = [], ns = [];
        a.forEach(function (o, k) {
          if (!o) return; sum += +o.dataset.price; ids.push(o.dataset.id); ns.push(o.dataset.title);
          var pc = $('.twe-set__piece--' + (k ? 'b' : 'a'), st), img = pc && $('img', pc);
          if (img && img.dataset.cur !== o.dataset.img) {
            pc.classList.add('is-swap');
            setTimeout(function () { img.src = o.dataset.img; img.alt = o.dataset.title; img.dataset.cur = o.dataset.img; pc.classList.remove('is-swap'); }, RM ? 0 : 280);
          }
        });
        if (total) total.textContent = money(sum);
        if (names) names.textContent = ns.join(' + ');
        if (add) add.dataset.tweAdd = ids.join(',');
      }
      groups.forEach(function (g) {
        $$('.twe-set__opt', g).forEach(function (o) {
          o.addEventListener('click', function () { $$('.twe-set__opt', g).forEach(function (x) { x.setAttribute('aria-pressed', x === o); }); upd(); });
        });
      });
      var dice = $('[data-twe-dice]', st);
      dice && dice.addEventListener('click', function () {
        groups.forEach(function (g) { var os = $$('.twe-set__opt', g); var o = os[Math.floor(Math.random() * os.length)]; os.forEach(function (x) { x.setAttribute('aria-pressed', x === o); }); o.scrollIntoView({ block: 'nearest', inline: 'center', behavior: RM ? 'auto' : 'smooth' }); });
        upd();
      });
      upd();
    });
  }

  /* ---------- quiz ---------- */
  function quizzes(root) {
    $$('[data-twe-quiz]', root).forEach(function (qz) {
      var steps = $$('.twe-quiz__step', qz), res = $$('.twe-quiz__res', qz), bar = $('.twe-quiz__bar i', qz), score = [], k = 0;
      function show(n) {
        k = n; steps.forEach(function (s, j) { s.classList.toggle('is-active', j === n); });
        res.forEach(function (r) { r.classList.remove('is-active'); });
        bar && bar.style.setProperty('--p', (n / steps.length * 100) + '%');
      }
      function finish() {
        var best = 0; score.forEach(function (v, j) { if ((v || 0) > (score[best] || 0)) best = j; });
        steps.forEach(function (s) { s.classList.remove('is-active'); });
        bar && bar.style.setProperty('--p', '100%');
        var r = res[Math.min(best, res.length - 1)]; r && r.classList.add('is-active');
        try { window.Shopify && Shopify.analytics && Shopify.analytics.publish && Shopify.analytics.publish('twe_quiz', { result: r && r.dataset.name }); } catch (e) {}
      }
      $$('.twe-quiz__opt', qz).forEach(function (o) {
        o.addEventListener('click', function () {
          String(o.dataset.r || '').split(',').forEach(function (x) { if (x !== '') score[+x] = (score[+x] || 0) + 1; });
          if (k + 1 < steps.length) show(k + 1); else finish();
          var top = qz.getBoundingClientRect().top + scrollY - 90; if (scrollY > top) scrollTo({ top: top, behavior: RM ? 'auto' : 'smooth' });
        });
      });
      $$('[data-twe-restart]', qz).forEach(function (b) { b.addEventListener('click', function () { score = []; show(0); }); });
      show(0);
    });
  }

  /* ---------- lupa sobre materiales (solo con mouse) ---------- */
  function lenses(root) {
    if (!window.matchMedia('(hover: hover)').matches) return;
    $$('[data-twe-lens]', root).forEach(function (box) {
      var lens = document.createElement('i'); lens.className = 'twe-lens'; box.appendChild(lens);
      lens.style.backgroundImage = 'url("' + box.dataset.tweLens + '")';
      box.addEventListener('pointerenter', function () { box.classList.add('is-zoom'); });
      box.addEventListener('pointerleave', function () { box.classList.remove('is-zoom'); });
      box.addEventListener('pointermove', function (e) {
        var r = box.getBoundingClientRect(), x = e.clientX - r.left, y = e.clientY - r.top;
        lens.style.left = (x - 85) + 'px'; lens.style.top = (y - 85) + 'px';
        lens.style.backgroundPosition = (x / r.width * 100) + '% ' + (y / r.height * 100) + '%';
      });
    });
  }

  /* ---------- índice flotante de capítulos ---------- */
  function index() {
    var caps = $$('[data-twe-cap]'); var old = $('.twe-idx'); old && old.remove();
    if (!$('.twe-progress') && caps.length) { var p = document.createElement('div'); p.className = 'twe-progress'; document.body.appendChild(p); }
    if (caps.length < 3) return;
    var nav = document.createElement('nav'); nav.className = 'twe-idx'; nav.setAttribute('aria-label', 'Capítulos');
    caps.forEach(function (c, k) {
      if (!c.id) c.id = 'twe-cap-' + k;
      var a = document.createElement('a'); a.href = '#' + c.id; a.innerHTML = '<span>' + String(k + 1).padStart(2, '0') + ' · ' + c.dataset.tweCap + '</span>';
      a.addEventListener('click', function (e) { e.preventDefault(); c.scrollIntoView({ behavior: RM ? 'auto' : 'smooth' }); });
      nav.appendChild(a);
      onView(c, function (v) { if (v) { $$('a', nav).forEach(function (x, j) { x.classList.toggle('is-active', j === k); }); } }, { rootMargin: '-45% 0px -50% 0px', threshold: 0 });
    });
    document.body.appendChild(nav);
    onView(caps[0], function (v) { nav.classList.toggle('is-on', !v); }, { threshold: 0.35 });
    // líneas de portada
    $$('[data-twe-lines]').forEach(function (box) {
      box.innerHTML = '';
      caps.slice(1, 7).forEach(function (c, k) {
        var a = document.createElement('a'); a.className = 'twe-portada__line'; a.href = '#' + c.id;
        a.innerHTML = '<b class="twe-m">' + String(k + 2).padStart(2, '0') + '</b><span>' + c.dataset.tweCap + '</span>';
        a.addEventListener('click', function (e) { e.preventDefault(); c.scrollIntoView({ behavior: RM ? 'auto' : 'smooth' }); });
        box.appendChild(a);
      });
    });
  }

  function init(root) {
    root = root || document;
    reveals(root); videos(root); slides(root); stories(root); ticker(root); chapters(root);
    rails(root); hotspots(root); adders(root); sets(root); quizzes(root); lenses(root);
  }
  function boot() { init(document); index(); requestAnimationFrame(scrollFx); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); index(); });
})();
